import { Box, BoxProps } from '@chakra-ui/react';
import { Colors } from '@mercator-gcp/grout';
import { Spinner } from 'components/elements/Spinner';

type Props = {
  sx: BoxProps['sx'];
};

const OverlaySpinner = ({ sx }: Props) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: Colors.White,
        opacity: '60%',
        ...sx,
      }}
    >
      <Spinner />
    </Box>
  );
};

export default OverlaySpinner;
